<template>
  <popup-bg :show-lock="showLock" :full-page="true">
    <div slot="custom-html">
      <div class="filter-title">筛选</div>
      <div class="filter-wrap" v-if="typeof ds.roleids === 'object'">
        <h3>角色搜索</h3>
        <el-select
          v-model="searchData.roleid"
          title="选择角色"
          filterable>
          <el-option
            v-for="item in ds.roleids"
            :key="item.roleid"
            :label="item.name"
            :value="item.roleid"/>
        </el-select>
      </div>
      <div class="filter-wrap" v-if="typeof ds.group_list === 'object' && ds.group_list.length">
        <h3>小组搜索</h3>
        <el-select
          v-model="searchData.gid"
          title="选择小组"
          clearable
          filterable>
          <el-option
            v-for="(option, index) in ds.group_list"
            :key="index"
            :label="option.truename"
            :value="option.gid"/>
        </el-select>
      </div>
      <div class="filter-wrap" v-if="searchData.teacher_id">
        <h3>业务老师</h3>
        <el-select
          v-model="searchData.teacher_id"
          title="请选择"
          multiple
          filterable
          clearable>
          <el-option
            v-for="option in ds.teacher"
            v-if="filterTeacher(option)"
            :key="option.key"
            :label="option.name"
            :value="option.key"/>
        </el-select>
      </div>
      <div class="filter-wrap" v-if="searchData.timeline">
        <h3>起止时间</h3>
        <el-date-picker
          v-model="searchData.timeline"
          type="daterange"
          align="right"
          unlink-panels
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :editable="false"
          :clearable="false"
          format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="filter-wrap" v-if="typeof searchData.year !== 'undefined'">
        <h3>入学年月</h3>
        <el-select
          v-model="searchData.year">
          <el-option
            v-for="(option, index) in ds.year"
            :key="index"
            :label="option"
            :value="index"/>
        </el-select>
        <el-select
          v-model="searchData.month"
          multiple
          clearable>
          <el-option
            v-for="(option, index) in h5constDict.month"
            :key="index"
            :label="option"
            :value="index"/>
        </el-select>
      </div>
      <div class="filter-wrap" v-if="searchData.channel">
        <h3>渠道来源</h3>
        <jm-channel
          v-model="searchData.channel"
          clearable
          filterable/>
      </div>
      <div class="filter-btn-area">
        <el-button @click="clearSearchData">清空条件</el-button>
        <el-button @click="submit">开始查询</el-button>
      </div>
    </div>
    <div slot="close-button">
      <slot name="close-button"></slot>
    </div>
  </popup-bg>
</template>
<script>
import {
  // jmAreaselect,
  jmChannel,
  // jmEducationSelect,
  // jmExamjpSelect,
  jmDictSelect
} from '@/components/tool';
import popupBg from '@/pages/h5/compoments/popupBg';
import h5Common from '@/pages/h5/common';

export default {
  props: {
    showLock: {
      type: Boolean,
      default: false
    },
    searchData: {
      type: Object,
      default() {
        return {};
      }
    },
    searchDs: {
      type: String,
      default: '/index/b_i_channel/index'
    }
  },
  data() {
    return {
      ds: {},
      h5constDict: {
        month: ['全部', '1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
      },
      originSearchData: null
    };
  },
  components: {
    jmChannel,
    jmDictSelect,
    'popup-bg': popupBg
  },
  mixins: [h5Common],
  methods: {
    getDatasource() {
      return this.$http._get({
        url: this.searchDs,
      }).then((response) => {
        this.ds = response.data;
        // console.log('ds', this.ds);
        this.searchData.roleid = typeof this.ds.roleids === 'object' ? this.ds.roleids[0].roleid : this.ds.roleids;
        this.originSearchData = Object.assign({}, this.originSearchData, this.searchData);
        this.$emit('update:searchData', this.searchData);
        return Promise.resolve(this.ds);
      });
    },
    submit() {
      this.$emit('update:searchData', this.searchData);
      this.$emit('update:showLock', false);
    },
    clearSearchData() {
      this.searchData = Object.assign({}, this.originSearchData);
      this.$emit('update:searchData', this.searchData);
      this.$emit('update:showLock', false);
    },
    filterTeacher(option) {
      let group = (this.searchData.gid && this.searchData.gid === option.group_id) || !this.searchData.gid;
      let roleid = (this.searchData.roleid && this.searchData.roleid === option.role_id) || !this.searchData.roleid;
      // console.log(group, option.role_id, this.searchData.roleid);
      return group && roleid;
    }
  },
  mounted() {
    // console.log(this.searchData);
    this.getDatasource();
  }
};
</script>

<style scoped>
  .filter-title{
    font-size: 4.53vw;
    padding: 5vw 0 0;
    font-weight: 600;
    text-align: center;
  }
  .filter-wrap{
    padding: 0 4vw;
  }
  .filter-wrap > h3{
    font-size: 4.8vw;
    line-height: 5vw;
    padding: 7.4vw 0 3.7vw;
  }
  .filter-wrap .el-select{
    width: 100%;
  }
  .filter-wrap .jm-dict-select,.filter-wrap .jm-channel-select{
    width: 100%;
  }
  .filter-btn-area{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 19vw;
    line-height: 16vw;
    border-top: 1px solid #DFDEE3;
    background: #fff;
    z-index: 9;
    text-align: center;
  }
  .filter-btn-area .el-button{
    height: 10.6vw;
    line-height: 10.6vw;
    border-radius: 5.3vw;
    padding: 0;
    font-size: 3.73vw;
    color: #fff;
    background: #0496ff;
    width: 52vw;
    border: none;
  }
  .filter-btn-area .el-button:first-of-type{
    width: 36.5vw;
    background: #f8f8f8;
    color: #333;
  }
  .el-date-editor{
    width: 100%;
  }
  .magbot2{
    margin-bottom: 2vw;
  }
</style>
<style>
  .filter-wrap .jm-dict-select .el-select{
    width: 100% !important;
  }
  .filter-wrap .jm-channel-select .el-select{
    width: 100% !important;
    margin-right: 0;
    margin-bottom: 2vw;
  }
  @media (max-width: 1025px) {
    .el-date-range-picker{
      width: 100%;
      overflow-x: auto;
      overflow-y: hidden
    }
    .el-date-range-picker .el-picker-panel__body{
      width: 520px
    }
  }
  .channel-list-wrap .infinite-list-wrapper ul li{
    padding: 0 !important;
    border-radius: 0;
    margin-bottom: 0;
    margin-top: 2vw;
  }
  .channel-list-wrap2 .infinite-list-wrapper ul li{
    padding: 0 !important;
  }
  .wap-channel-wrap .rows-div{
    width: 100%;
    background: #FFFFFF;
    padding: 0 4vw 7vw;
    border-radius: 0 0 3vw 3vw;
    box-shadow: 0 2vw 2vw rgba(0,0,0,.05);
  }
  .wap-channel-wrap .rows-div.active{
    height: 0;
    padding:0;
    overflow: hidden;
  }
  .wap-channel-wrap .rows-div .chart-div {
    height: 50vw;
  }
  .wap-channel-wrap .top-info-area{
    background: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 4vw;
  }
  .wap-channel-wrap .top-info-area .s_title{
    font-size: 4.8vw;
  }
  .wap-channel-wrap .top-info-area .s_right{
    color: #969696;
    font-size: 3.46vw;
  }
  .wap-channel-wrap .top-info-area .el-select{
    width: 26vw;
    font-size: 3.46vw;
    margin: 0 2vw 0 1vw;
  }
  .wap-channel-wrap .top-info-area .el-button{
    width: 16vw;
    height: 28px;
    line-height: 28px;
    background: #f1f1f1 url("../../../../assets/wap/icon-filter.png") no-repeat 84% center;
    background-size: 3.6vw auto;
    color: #666;
    border: none;
    margin-right: 0;
    padding: 0 3.5vw 0 0;
    font-size: 3.46vw;
  }
  .wap-channel-wrap .top-info-area .el-button.active{
    background: rgba(4, 150, 255, 0.1) url("../../../../assets/wap/icon-filteron.png") no-repeat 84% center;
    background-size: 3.6vw auto;
    color: #0496ff;
  }
  .wap-channel-wrap .channel-list-wrap{
    width: 92vw;
    border-radius: 3vw;
    background: #fff;
    margin: 4vw auto;
    padding: 3vw;
  }
  .wap-channel-wrap .channel-list-wrap2{
    padding: 4vw;
  }
  .wap-channel-wrap .channel-list-wrap .list-title{
    display: flex;
    background: #F4F7FE;
    line-height: 10.1vw;
    border-radius: 1.6vw;
    font-size: 3.46vw;
    color: #0496ff;
    padding: 0 3vw;
  }
  .wap-channel-wrap .channel-list-special{
    line-height: 10.1vw;
    font-size: 3.46vw;
    padding:3vw 4vw;
  }
  .wap-channel-wrap .channel-list-special div{
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 4vw;
    width: 90%;
    margin: auto;
    border-bottom: 1px dashed #D1DAF2;
  }
  .wap-channel-wrap .channel-list-special div:nth-of-type(1){
    justify-content: center;
    background: #F4F7FE;
    border-radius: 1.6vw;
    border: none;
    width: 100%;
    font-size: 4.2vw;
    color: #333;
    font-weight: bold;
  }
  .wap-channel-wrap .channel-list-special div:last-of-type{
    border: none;
  }
  .wap-channel-wrap .channel-list-level{
    display: flex;
    justify-content: space-between;
    align-items: center;
    line-height: 10.1vw;
    font-size: 3.46vw;
    padding: 0 3vw;
  }
  .wap-channel-wrap .channel-list-level.channel-list-level1{
    background: #F4F7FE;
    border-radius: 1.6vw;
  }
  .wap-channel-wrap .channel-list-level.channel-list-level2{
    border-bottom: 1px dashed #D1DAF2;
  }
  .wap-channel-wrap .channel-list-level.channel-list-level2:last-of-type{
    border-bottom: none;
  }
  .wap-channel-wrap .channel-list-wrap .list-title div, .channel-list-level div{
    white-space: nowrap;
    text-align: center;
  }
  .wap-channel-wrap .channel-list-wrap .list-title div:nth-of-type(1), .channel-list-level div:nth-of-type(1){
    flex: 4;
    text-align: left;
  }
  .wap-channel-wrap .channel-list-level div:nth-of-type(1) span{
    position: relative;
    color: #0496ff;
    padding-left: 3.5vw;
  }
  .wap-channel-wrap .channel-list-level div:nth-of-type(1) i{
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    border-top: 1.6vw solid #0496ff;
    border-left: 1.2vw solid transparent;
    border-right: 1.2vw solid transparent;
    transition: all linear 0.2s;
  }
  .wap-channel-wrap .channel-list-level div:nth-of-type(1) i.active{
    transform: translateY(-50%) rotate(180deg);
  }
  .wap-channel-wrap .channel-list-wrap .list-title div:nth-of-type(2),.wap-channel-wrap  .channel-list-level div:nth-of-type(2){
    flex: 2;
  }
  .wap-channel-wrap .channel-list-wrap .list-title div:nth-of-type(3),.wap-channel-wrap  .channel-list-level div:nth-of-type(3){
    flex: 2;
  }
  .wap-channel-wrap .channel-list-wrap .list-title div:nth-of-type(4),.wap-channel-wrap  .channel-list-level div:nth-of-type(4){
    flex: 2.5;
  }
  .btn-chart-slide{
    padding:0;
    border: none;
    font-size: 0;
    position: fixed;
    right: 4vw;
    bottom: 9%;
    width: 10vw;
    height: 10vw;
    border-radius: 100%;
    background: #0496ff url(../../../../assets/wap/icon-channel-arrow.png) no-repeat center;
    background-size: 3.8vw auto;
  }
  .btn-chart-slide:hover,.btn-chart-slide:focus,.btn-chart-slide:active{
    background: #0496ff url(../../../../assets/wap/icon-channel-arrow.png) no-repeat center;
    background-size: 3.8vw auto;
  }
  .btn-chart-slide.active{
    transform: rotate(180deg);
  }
</style>
